import { Component, ComponentType } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { compose } from 'redux';
import { IApplicationState } from '@bridebook/web/lib/types';
import { getScreenType } from '@bridebook/web/lib/app/selectors';

const ViewPortBuggyFill = process.browser ? require('viewport-units-buggyfill') : null;

const storeEnahncer = connect((state: IApplicationState) => ({
  isMobile: getScreenType(state).isMobile,
  isTablet: getScreenType(state).isTablet,
}));

interface IProps extends ConnectedProps<typeof storeEnahncer> {}

/**
 * Viewport units buggyfill Higher Order Component
 */
const buggyfill = (WrappedComponent: ComponentType) =>
  class Wrapper extends Component<IProps> {
    componentDidMount() {
      const { isMobile, isTablet } = this.props;
      if ((isMobile || isTablet) && ViewPortBuggyFill) {
        try {
          ViewPortBuggyFill.init({ force: true });
          ViewPortBuggyFill.refresh();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
        }
      }
    }

    render() {
      // @ts-ignore FIXME
      return <WrappedComponent {...this.props} />;
    }
  };

export default compose<ComponentType>(storeEnahncer, buggyfill);
